export enum OperatorEnum {
  AND = 'AND',
  OR = 'OR',
}
